namespace advisorop.components.advisor {

    class AdvisorMonitorsController {
        public advisorId;
        $router;
        user: domains.identity.IUser;
        show: string = "";
        firmId: number = 0;
        titleSuffix: string = "";
        PeriodicWithIssuesCount: number;
        PeriodicDepIssuesCount: number;
        NonzeroFundingIssuesCount: number;
        CashMonitorIssuesCount: number;
        NegcashMonitorIssuesCount: number;
        UncategorizedSecuritiesMonitorIssuesCount: number;

        static $inject = ["identityService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService) {

        }

        // If we want to reinstate this, do not do it as function, set a variable.
        //isServicerAdmin(): boolean {
        //    return (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        //}

        $onInit(): void {
            this.advisorId = 1;

            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
        }

        $routerOnActivate(next, previous) {
            this.show = <string>next.params.show;
        }
    }



    class AdvisorMonitors implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorMonitorsController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/advisor-monitors.html';
        }
    }
    angular.module(Constants.APP).component("advisorMonitors", new AdvisorMonitors());


}